<template lang="pug">
  a(:href='destination', :target='target', :title='title', @click="doClick();$emit('click')")
    slot
</template>

<script>
import analytics from '@api/analytics';
import trackingUtil from '@api/trackingUtil';

export default {
  name: 'ExternalLink',
  props: {
    href: String,
    target: {
      type: String,
      default: '_blank'
    },
    title: String
  },
  computed: {
    destination: function () {
      return trackingUtil.getDestination(this.href, this.$route.name);
    }
  },
  methods: {
    doClick: function () {
      analytics.event(analytics.events.EXTERNAL, {
        item_id: this.href
      });
    }
  }
}
</script>